module.exports = __webpack_public_path__ + "static/img/content-img.53617f95.png";